/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  // 如果 content 是 null 或 undefined，也需要保存（保存为 "null" 字符串）
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  try {
    window.localStorage.setItem(name, content)
  } catch (e) {
    console.error(`💾 setStore 保存失败: ${name}`, e)
  }
}

/**
 * 获取localStorage
 */
export const getStore = (name) => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = (name) => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 存储sessionStorage
 */
export const setSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSession = (name) => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除sessionStorage
 */
export const removeSession = (name) => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}

/**
 * 清空会话缓存（仅 sessionStorage）
 * 注意：切勿 localStorage.clear()，会误删入学诊断 verifyToken 等持久数据
 */
export const clearSession = () => {
  try {
    window.sessionStorage.clear()
  } catch (e) {
    console.error('clearSession 失败', e)
  }
}
